<template>
    <div>
        <div class="row mb-n3">
            <div class="col-md-4 col-lg-3 mb-3">
                <label for="month">Mois</label>
                <select id="month" class="custom-select" v-model="value.month" @change="handleChanged">
                    <option :value="null">tous</option>
                    <template v-for="(label, value) in criterias.months">
                        <option :value="value">{{ label }}</option>
                    </template>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: Object,
            criterias: Object,
        },
        methods: {
            handleChanged() {
                this.$emit('input', {
                    ...this.value,
                });
            },
        }
    }
</script>
